<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label"> {{$t("message.name") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                :placeholder="$t('message.name')"
                v-model="searchName"
                name="search"
                class="form-control input"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">{{$t("message.Category") }}</label>
          <div class="col-sm-3">
            <select class="form-control" v-model="categoryId" name="categoryId">
              <option  class="ng-binding" value="">{{$t("message.All") }}</option>
              <option  class="ng-binding" v-for="category in resourceGroupList" v-bind:value="category.id">{{category['name'+$i18n.locale]}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive">
              <div class="col-xs-12">{{rows.length}}{{$t("message.datagridresult") }}</div>
              <datatable :columns="columns" :data="rows">
                <template scope="{ row }">
                  <tr @dblclick="datataleCli(row)" :style="trStyle">
                    <td align="center">
                      <select-row :row="row"></select-row>
                    </td>
                    <td>
                      <span>{{row['name'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row.createdTime}}</span>
                    </td>
                  </tr>
                </template>
              </datatable>
              <datatable-pager
                align="right"
                :style="navStaty"
                :per-page="per_page"
                type="short"
                v-model="page"
              ></datatable-pager>
            </div>
            <div class="col-sm-12" style="margin-top:-30px;">
              <div class="pull-right">
                <button
                  class="btn btn-white"
                  @click="gotoDetail"
                >{{$t("message.Add") }}</button>
                <button class="btn btn-white" @click="showWarning">{{$t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import selectall from "../components/common/selectAll";
import selectrow from "../components/common/selectRow";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {
    Multiselect ,
    "select-row": selectrow,
    "select-all": selectall
  },
  data() {
    return {
      page: 1,
      per_page: 20,
      filter: "",
      superLength: 0,
      superFalg: true,
      trStyle: {
        cursor: "pointer"
      },
      navStaty: {
        "margin-top": "-30px",
        "margin-bottom": "15px",
        "margin-right": "30px"
      },
      columns: [
      ],
      rows: [
        {
          nameEN: "",
          createdTime:""
        }
      ],
      selected_rows: [],
      searchName: "",
      searchStatus: null,
      resourceGroupList:[],
      categoryId:"",
      value: [],
      options: [
        { name: 'Active', id: 1 },
        { name: 'Inactive', id: 0 }
      ]
    };
  },
  created: function() {
    eventBus.$on(
      "selected",
      function(row) {
        if (this.selected_rows.indexOf(row) === -1) {
          this.selected_rows.push(row);
        }
        let selectPublisher = 0;
        let superLength = this.superLength;
        for (var i = 0; i < this.selected_rows.length; i++) {
          if (this.selected_rows[i].roleId === "Publisher") {
            selectPublisher++;
            if (selectPublisher == superLength) {
              this.superFalg = false;
              return;
            }
          }
        }
      }.bind(this)
    );

    eventBus.$on(
      "deselected",
      function(row) {
        if (this.selected_rows.indexOf(row) !== -1) {
          let index = this.selected_rows.indexOf(row);
          this.selected_rows.splice(index, 1);
        }
        let selectPublisher = 0;
        let superLength = this.superLength;
        for (var i = 0; i < this.selected_rows.length; i++) {
          if (this.selected_rows[i].roleId === "Publisher") {
            selectPublisher++;
          }
        }
        if (selectPublisher < superLength) {
          this.superFalg = true;
        }
      }.bind(this)
    );

    eventBus.$on(
      "select-all",
      function(selected) {
        Vue.set(this, "selected_rows", this.rows.slice(0));
      }.bind(this)
    );

    eventBus.$on(
      "deselect-all",
      function(selected) {
        Vue.set(this, "selected_rows", []);
      }.bind(this)
    );
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    publisherLength() {
      let userList = this.rows;
      let superLength = 0;
      for (var i = 0; i < userList.length; i++) {
        if (userList[i].roleId === "Publisher") {
          superLength++;
        }
      }
      this.superLength = superLength;
    },
    init() {
      this.getResourceList();
      this.getResourceGroupList();
    },
    async getResourceList() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      objdata.name = this.searchName;
      objdata.resourceGroupId = this.categoryId;
      let data = await this.$store.dispatch("getResourceList", this.setFormData(objdata));
      let list = null;
      for(var i=0;i<data.data.resultList.length;i++){
        for(var j=0;j<data.data.resultList[i].langData.length;j++){
          if(data.data.resultList[i].langData[j].langCode=="en_US"){
            data.data.resultList[i]['name'+'en_US'] = data.data.resultList[i].langData[j].name;
          }
          if(data.data.resultList[i].langData[j].langCode=="zh_HK"){
            data.data.resultList[i]['name'+'zh_HK'] = data.data.resultList[i].langData[j].name;
          }
          if(data.data.resultList[i].langData[j].langCode=="zh_CN"){
            data.data.resultList[i]['name'+'zh_CN'] = data.data.resultList[i].langData[j].name;
          }
        }
      }
      this.rows = data.data.resultList;
    },
    async getResourceGroupList() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      objdata.name = this.searchName;
      let data = await this.$store.dispatch("getResourceGroupList", this.setFormData(objdata));
      let list = null;
      for(var i=0;i<data.data.resultList.length;i++){
        for(var j=0;j<data.data.resultList[i].langData.length;j++){
          if(data.data.resultList[i].langData[j].langCode=="en_US"){
            data.data.resultList[i]['name'+'en_US'] = data.data.resultList[i].langData[j].name;
          }
          if(data.data.resultList[i].langData[j].langCode=="zh_HK"){
            data.data.resultList[i]['name'+'zh_HK'] = data.data.resultList[i].langData[j].name;
          }
          if(data.data.resultList[i].langData[j].langCode=="zh_CN"){
            data.data.resultList[i]['name'+'zh_CN'] = data.data.resultList[i].langData[j].name;
          }
        }
      }
      this.resourceGroupList = data.data.resultList;
    },
    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/resourceDetail" });
    },
    datataleCli(row) {
      this.$router.push({
        path: "/main/resourceDetail",
        query: { id: row.id }
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.getResourceList();
    },
    showWarning() {
      var that =this;
      if (this.selected_rows.length != 0) {
        if (this.selected_rows.length == this.rows.length) {
          this.$store.commit("setwarning", {
            string: "Always keep at least 1 Publisher",
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }],
          });
        } else if (!this.superFalg) {
          this.$store.commit("setwarning", {
            string: "Always keep at least 1 Publisher",
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
          });
        } else {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.deleteList();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }],
            
          });
        }
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj;
      if (this.selected_rows.length != 0) {
        for (let i = 0; i < this.selected_rows.length; i++) {
          ids.push(this.selected_rows[i].id);
        }
      }
      objdata.ids = ids;

      let data = await this.$store.dispatch("deleteResource", this.setFormData(objdata));
      if (data.data.errorCode === 0) {
        this.selected_rows=[]
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    setColumns:function(){
      this.columns = [
        {
          label: "",
          align: "center",
          component: selectrow,
          headerComponent: selectall
        },
        { label: this.$i18n.t("message.name")+" - EN", field: "name"+this.$i18n.locale },
        { label: this.$i18n.t("message.createdTime"), field: "createdTime" },
      ]
    }
  },
  mounted() {
    this.setColumns();
    this.init();
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    selected_rows: function() {
      for (var row of this.rows) {
        if (this.selected_rows.indexOf(row) === -1) {
          return;
        }
      }
      eventBus.$emit("all-selected");
    },
    _language:function(){
      this.setColumns();
    }
  }
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
</style>